import { TipoDocumentoAPI } from '@/api/tipo-documento.api';
import { Pagination } from '@/api/pagination';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { TipoDocumento, PageTipoDocumentoInput } from "@/models/tipo-documento"


const api = new TipoDocumentoAPI();

const list = (params: any): Observable<any> => {
  return api.list(params);
}

const show = (id: number): AxiosObservable<TipoDocumento> => {
  return api.show(id);
}

const updateFields = (id: number, documentFields: any[]): AxiosObservable<TipoDocumento> => {
  const body = { type_document: { document_fields: documentFields } };

  return api.update(id, body);
}

export default {
  list,
  show,
  updateFields,
}
